import React from 'react'
import Calculator from '../components/Calculator'

const EmiCalculator = () => {
  return (
    <div className="sm:h-[90vh]  w-[100%] flex flex-col justify-center items-center calcu">
    <Calculator/>

    </div>
  )
}

export default EmiCalculator